import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import PermissionDeniedPage from "app/Pages/Errors/PermissionDeniedPage";
import { RootState } from "store";

const RootContainer = styled("div")({
  minHeight: "70vh",
  margin: "auto",
});

interface HostRouteProps {
  children: React.ReactNode;
}

function HostRoute({ children }: HostRouteProps): JSX.Element {
  const claims = useSelector((state: RootState) => state.user.token);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (claims) {
      setLoading(false);
    }
  }, [claims]);

  const renderContent = (): React.ReactNode => {
    if (loading) {
      return <CircularProgress />;
    }
    if (claims && claims.isHost) {
      return children;
    }
    return <PermissionDeniedPage />;
  };

  return <RootContainer>{renderContent()}</RootContainer>;
}

export default HostRoute;
